
import React, { useEffect, useRef, useState, useContext } from 'react'

import BrowserReal from '../BrowserPages/BrowserReal';
import Mobilereal from '../MobilePages/Mobilereal';
import { Helmet } from "react-helmet";
import { AdvancedRealTimeChart } from "react-ts-tradingview-widgets";
import Mobilenav from '../Components/Mobilenav';
import Browsernav from '../Components/Browsernav';
import { CryptoPairs, Forexpairs, Stockpairs } from "../Pairs"
import { f, database, storage, auth } from "../config";
import db from "../config";
import { GlobalContext } from "../Globalstate";
import { useNavigate, Link } from "react-router-dom";
import Swal from 'sweetalert2'
import firebase from 'firebase';

function Demo() {

    const history = useNavigate();
    const [{ userdetails, loggedin, tradingpair, openorders, adminstaus }, dispatch] = useContext(GlobalContext);
    const [PairsToRender, setPairsToRender] = useState([])
    const [TradingSection, setTradingSection] = useState("forex")
    const [selectedPaird, setselectedPaird] = useState("EURUSD")
    const [loading, setloading] = useState(true)
    const [AmountToTrade, setAmountToTrade] = useState("")
    const [Adminstas, setAdminstas] = useState("")

    const [commodityPrice, setcommodityPrice] = useState("")
    const [percentage, setpercentage] = useState("5")
    const [TradeTime, setTradeTime] = useState("60")

    const ChangePairsToRender = (values) => {
        console.log("hgfufyfyufyfyf")
        if (values == "crypto") {
            setPairsToRender(CryptoPairs)
            setTradingSection("crypto")
            setselectedPaird(CryptoPairs[0].tradingsymbol)
        }
        else if (values == "stocks") {
            setPairsToRender(Stockpairs)
            setTradingSection("stocks")
            setselectedPaird(Stockpairs[0].name)
        }
        else if (values == "forex") {
            setPairsToRender(Forexpairs)
            setTradingSection("forex")
            setselectedPaird(Forexpairs[0].fromsymbol + Forexpairs[0].tosymbol)
        }
    }

    const setselectedPair = (values) => {
        setselectedPaird(values)
    }

    const PlaceOder = async (CallTYpe) => {
        Swal.fire({
            title: `Place a ${CallTYpe} Trade on ${selectedPaird}?`,
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                RunTrade(CallTYpe)
            }
        })
        console.log(CallTYpe)
    }

    // --- UPDATED RUNTRADE FUNCTION (NO API CALLS) ---
    const RunTrade = async (CallTYpe) => {
        if (!PairsToRender || PairsToRender.length === 0) {
            Swal.fire('No Selected Pair?', 'Please Select A trading pair?', 'warning')
            return
        }

        let obj;
        if (TradingSection === "crypto") {
            obj = CryptoPairs.find(o => o.tradingsymbol === selectedPaird);
        } else if (TradingSection === "forex") {
            obj = Forexpairs.find(o => o.symbol === selectedPaird);
        } else if (TradingSection === "stocks") {
            obj = Stockpairs.find(o => o.name === selectedPaird);
        }

        if (!obj) {
            Swal.fire('Error', 'Could not find details for the selected pair.', 'error')
            return;
        }

        // HARDCODED PRICE: No API calls are made
        const fixedPrice = 0.00001;
        await setcommodityPrice(fixedPrice);
        console.log("Using hardcoded price for trade:", fixedPrice);

        ProcessTrade(obj, CallTYpe, fixedPrice);
    }

    const ProcessTrade = async (TradeDetails, CallTYpe, priceCom) => {
        console.log(percentage, TradeTime)
        var currenTTime = new Date();
        currenTTime.setSeconds(currenTTime.getSeconds() + parseInt(TradeTime));
        console.log(currenTTime)

        if (AmountToTrade == "") {
            Swal.fire('No Selected Price?', 'select a price for the trade', 'warning')
            return
        }

        if (parseFloat(AmountToTrade) > parseFloat(userdetails.demobalance)) {
            Swal.fire('Low Balance', 'Balance is not enough', 'error')
            return
        }

        const currentbal = parseFloat(userdetails.demobalance) - parseFloat(AmountToTrade)
        let formerorders = userdetails.Demoopenorders
        console.log(userdetails.Demoopenorders)
        updateUserBalance(currentbal)

        if (adminstaus == true) {
            const new_order = {
                tradeDetails: TradeDetails,
                CallTYpe: CallTYpe,
                commodityPrice: priceCom,
                percentage: percentage,
                AmountToTrade: AmountToTrade,
                AdminOnline: "NO", 
                status: "pending", 
                ExpirationTime: currenTTime.getTime(),
            }
            updateDemoopenorders(new_order)
            var userid = f.auth().currentUser;
            var userids = userid.uid;
            var washingtonRef2 = await db.collection("DemoOpenoders").doc("iEkPQf9sYa3Puj1IW76Z");
            await washingtonRef2.update({
                alltrades: firebase.firestore.FieldValue.arrayUnion({ order: new_order, userID: userids })
            });

            Swal.fire('Succes!', 'Your Trade Has Been Executed.', 'success')
            routeOrders()
        } else if (adminstaus == false) {
            const new_order = {
                tradeDetails: TradeDetails,
                CallTYpe: CallTYpe,
                commodityPrice: priceCom,
                percentage: percentage,
                AmountToTrade: AmountToTrade,
                AdminOnline: "NO", 
                status: "loose", 
                ExpirationTime: currenTTime.getTime(),
            }
            updateDemoopenorders(new_order)

            Swal.fire('Succes!', 'Your Trade Has Been Executed.', 'success')
            routeOrders()
        }
    }

    const updateDemoopenorders = async (order) => {
        var userid = f.auth().currentUser;
        var userids = userid.uid;
        var washingtonRef = await db.collection("users").doc(userids);
        await washingtonRef.update({
            Demoopenorders: firebase.firestore.FieldValue.arrayUnion(order)
        });
    }

    const updateUserBalance = async (bal) => {
        var userid = f.auth().currentUser;
        var userids = userid.uid;
        var washingtonRef = await db.collection("users").doc(userids);
        await washingtonRef
            .update({
                demobalance: bal
            })
            .then(function () {
                console.log("Document successfully up2dated!");
            })
            .catch(function (error) {
                console.error("Error updating document: ", error);
            });
    };

    const routeOrders = async () => {
        console.log(userdetails.Demoopenorders)
        var userid = f.auth().currentUser;
        var userids = userid.uid;

        var docRef = db.collection("users").doc(userids);
        const fetching = await docRef
            .get()
            .then(function (doc) {
                if (doc.exists) {
                    setdetails(doc.data());
                    setopenordersD(doc.data().Demoopenorders)
                    console.log(doc.data().Demoopenorders)
                    setloading(false)
                    history("/demorunnig")
                } else {
                    console.log("No such document!");
                    setloading(false)
                }
            })
            .catch(function (error) {
                console.log("Error getting document:", error);
            });
    }

    useEffect(() => {
        if (loggedin) {
            console.log(userdetails);
            console.log(userdetails.email);
            setloading(false)
        } else {
            f.auth().onAuthStateChanged(function (user) {
                if (user) {
                    var userid = f.auth().currentUser;
                    var userids = userid.uid;
                    fetchuserdata(userids);
                    GetAdminStatus()
                    setloggedin(true);
                } else {
                    setloggedin(false);
                    setloading(false)
                    history("/");
                }
            });
        }
    }, []);

    const GetAdminStatus = async () => {
        await db.collection("Adminonline").doc("szQGPiQbBF3FQ5yRvxVC")
            .onSnapshot((doc) => {
                if (doc.exists) {
                    setAdminstas(doc.data().Adminonline)
                    console.log(doc.data().Adminonline)
                    dispatch({ type: "setadminstaus", snippet: doc.data().Adminonline });
                } else {
                    console.log("No such document!");
                }
            });
    }

    const fetchuserdata = async (userid) => {
        var docRef = db.collection("users").doc(userid);
        const fetching = await docRef
            .get()
            .then(function (doc) {
                if (doc.exists) {
                    setdetails(doc.data());
                    setopenordersD(doc.data().Demoopenorders)
                    console.log(doc.data().Demoopenorders)
                    CheckTrades(doc.data().Demoopenorders, doc.data())
                    setloading(false)
                } else {
                    console.log("No such document!");
                    setloading(false)
                }
            })
            .catch(function (error) {
                console.log("Error getting document:", error);
            });
    };

    const CheckTrades = async (OpenD, user) => {
        let neworders = []
        for (let i in OpenD) {
            const nowTime = new Date();
            const secs = ((OpenD[i].ExpirationTime - nowTime.getTime()) / 1000)

            if (secs == 0 || secs < 0) {
                var Tradeindex = neworders.indexOf(OpenD[i])
                neworders.splice(Tradeindex, 1)
                console.log("fuck")
                var userid = await f.auth().currentUser;
                var userids = userid.uid;

                var washingtonRef = await db.collection("users").doc(userids);
                await washingtonRef.update({
                    Demoopenorders: firebase.firestore.FieldValue.arrayRemove(OpenD[i])
                })

                const tarde = OpenD[i]
                var washingtonRef2 = await db.collection("DemoOpenoders").doc("iEkPQf9sYa3Puj1IW76Z");
                washingtonRef2.update({
                    alltrades: firebase.firestore.FieldValue.arrayRemove({ tarde, userID: userids })
                }).then(function () {
                    console.log("opppgfhfhchcc")
                })
                    .catch(function (error) {
                        console.log(error);
                    });

                if (OpenD[i].status == "win") {
                    await washingtonRef
                        .update({
                            demobalance: parseFloat(user.demobalance) + parseFloat(OpenD[i].AmountToTrade) + parseFloat(parseFloat(OpenD[i].AmountToTrade) * (parseFloat(OpenD[i].percentage) / 100))
                        })
                        .then(function () {
                            console.log("Document successfully up2dated!");
                        })
                        .catch(function (error) {
                            console.error("Error updating document: ", error);
                        });
                    history("/real")
                } else if (OpenD[i].status == "loose") {
                    console.log("passrby")
                } else {
                    await washingtonRef
                        .update({
                            demobalance: parseFloat(user.demobalance) + parseFloat(OpenD[i].AmountToTrade)
                        })
                        .then(function () {
                            console.log("Document successfully up2dated!");
                        })
                        .catch(function (error) {
                            console.error("Error updating document: ", error);
                        });
                    history("/real")
                }

                var washingtonRef = await db.collection("users").doc(userids);
                await washingtonRef.update({
                    Demoorderhistory: firebase.firestore.FieldValue.arrayUnion(OpenD[i]),
                });
            } else {
                neworders.push(OpenD[i])
                console.log("jjjj")
            }
        }
        setopenordersD(neworders.reverse())
        console.log("bbibwcbyib")
    }

    const setopenordersD = (data) => {
        console.log(data)
        dispatch({ type: "setDemoopenorders", snippet: data });
    };

    const setdetails = (data) => {
        dispatch({ type: "setuserdetails", snippet: data });
    };

    const setloggedin = (data) => {
        dispatch({ type: "setloggedin", snippet: data });
    };

    const tradingvi = useRef();

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
        script.innerHTML = `
        "symbols": [
            { "proName": "FOREXCOM:SPXUSD", "title": "S&P 500" },
            { "proName": "FOREXCOM:NSXUSD", "title": "Nasdaq 100" },
            { "proName": "FX_IDC:EURUSD", "title": "EUR/USD" },
            { "proName": "BITSTAMP:BTCUSD", "title": "BTC/USD" },
            { "proName": "BITSTAMP:ETHUSD", "title": "ETH/USD" }
        ],
            "showSymbolLogo": true,
            "colorTheme": "dark",
            "isTransparent": true,
            "displayMode": "adaptive",
            "locale": "en"
        `;
        if (tradingvi.current) {
            tradingvi.current.appendChild(script);
        }
    }, []);

    return (
        <div>
            <div className="root-content">
                <Helmet>
                    <meta httpEquiv="content-type" content="text/html; charset=UTF-8" />
                    <meta charSet="utf-8" />
                    <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
                    <title> ATA-trades Main </title>
                    <meta name="description" content="" />
                    <link rel="shortcut icon" type="image/png" sizes="32x32" href="assets/img/favicon.png" />
                    <link rel="shortcut icon" type="image/png" sizes="16x16" href="assets/img/favicon.png" />
                    <link rel="canonical" href="dashboard" />
                    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1" />
                    <link href="/dashboard/assets/css/css.css" rel="stylesheet" type="text/css" />
                    <link rel="stylesheet" type="text/css" href="/dashboard/assets/inner.css" />
                    <link rel="stylesheet" type="text/css" href="/dashboard/assets/app.css" />
                    <link rel="stylesheet" type="text/css" href="/dashboard/assets/cs.css" />
                    <script async="" src="/dashboard/assets/js/js.js"></script>
                    <script type="text/javascript" src="/dashboard/assets/js/sweet-alert.js"></script>
                    <script src="/dashboard/assets/inner.js"></script>
                    <script src="/js/app.js"></script>
                    <script src="/dashboard/assets/inner.js"></script>
                    <script src="/dashboard/assets/js/vendor.js"></script>
                    <script src="/dashboard/assets/app.js"></script>
                    <script type="text/javascript" src="validation.min.js"></script>
                    <script type="text/javascript" src="trade_script.js"></script>
                    <script type="text/javascript" src="trade_script2.js"></script>
                    <script src="https://use.fontawesome.com/4b789087e7.js"></script>
                </Helmet>

                <Mobilenav />
                <div id="google_translate_element"></div>
                <div className="pusher" aria-hidden="false">
                    <nav className="top-nav inner inner-new">
                        <div className="top-bar" style={{ height: '50px' }}>
                            <div className="head-row clearfix">
                                <div className="float-left ">
                                    <div className="logosm">
                                        <a ><img src="/assets/img/toplogo.png" alt="ProvidusOption" /></a>
                                    </div>
                                    <div className="ui item dropdown dropdown-call dinb" tabIndex={0}>
                                        <div className="top-bar-nav">
                                            <div className="phone-open" />
                                        </div>
                                        <div className="menu transition hidden" tabIndex={-1}>
                                            <div className="item">
                                                <div className="phone-notice">Please input your phone number with<br />country code and we will immediately contact you.</div>
                                                <div>+<input className="call-input" placeholder="phone" type="text" maxLength={20} id="callback" style={{ width: '200px' }} /><button className="button ui green-bm" id="call_btn" onClick={() => {}}>Call back</button></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <span className="menu-toggle float-right"><i /></span>
                                <div className="float-right nav smcapy-nav">
                                    <div className="ui item lang pointing dropdown" tabIndex={0}>
                                        <input type="hidden" name="lang" />
                                        <div className="default text">
                                            <div id="google_translate_element" className="google-trans" />
                                        </div>
                                        <i className="dropdown icon" />
                                    </div>
                                    <div className="item"><span style={{ color: '#eee' }}>Account Status:</span>
                                        <span style={{ color: '#0f0' }} className="blinkgreen"><i className="fa fa-check-circle" /> Active</span>
                                    </div>
                                    <div className="item"><a className="ui button op link a-green-hover" href="logout.php"><i className="fa fa-power-off" /> Exit</a></div>
                                    <div className="item"><a className="ui button op nobold" style={{ background: '#07b18c' }} href="/deposit"> Account Funding</a></div>
                                </div>
                            </div>
                        </div>
                        <div className="top-line clearfix">
                            <div className="row-30">
                                <ul className="icon-nav">
                                    <li className="active"><a target="_blank" title="Charting tools" className="technic" href="chart.php" style={{ color: '#FFFFFF' }}><i className="fa fa-bar-chart" /></a></li>
                                    <li className="active"><a title="Fundamental analysis" className="fundament" href="fundamental-analysis.php" target="_blank" style={{ color: '#FFFFFF' }}><i className="fa fa-pie-chart" /></a></li>
                                    <li className="active"><a title="News" className="expert" href="news.php" target="_blank" style={{ color: '#FFFFFF' }}><i className="fa fa-tv" /></a></li>
                                    <li className="active"><a title="Technical Analysis" className="ideas" href="technical-analysis.php" target="_blank" style={{ color: '#FFFFFF' }}><i className="fa fa-signal" /></a></li>
                                    <li className="active"><a title="Economic calendar" className="calendar" href="calendar.php" target="_blank" style={{ color: '#FFFFFF' }}><i className="fa fa-calendar" /></a></li>
                                </ul>
                            </div>
                            <Browsernav />
                        </div>
                    </nav>
                    <link rel="stylesheet" href="assets/platform.css" />
                    <style dangerouslySetInnerHTML={{ __html: "\n.red{background:#f7495c !important}\n.red:hover{background:#FF6071 !important}\n.red:active{background:#FF0000 !important}\n.green:active{background:#008800 !important}\nhr{\nborder:none;\nfont-size:2px;\n}\n.hidden{\ndisplay:none;\n}\n.trading-iframe{margin-left:220px; margin-right:235px; min-height:600px !important; height: 600px;}\n.menu-toggle{display:none;height:30px;width:25px;cursor:pointer;margin-top:19px; z-index:99999999 !important;}.menu-toggle i,.menu-toggle:after,.menu-toggle:before{display:block;width:100%;height:2px;background:#2597c7}.menu-toggle i{margin-top:6px}.menu-toggle:before{content:'';margin-top:3px}.menu-toggle:after{content:'';margin-top:6px}\n\n.lefttabnav{display:none;height:30px;width:25px;cursor:pointer;margin-top:30px; position:relative; top:0px; left:0; z-index:9999 !important}\n.lefttabnav i,.lefttabnav:after,.lefttabnav:before{display:block;width:100%;height:2px;background:#2597c7}\n.lefttabnav i{margin-top:6px}\n@media (max-width:1139px){\n.lefttabnav{display:none;float:left;margin-left:0}\n.lefttabnav:before{content:'';margin-top:3px}.lefttabnav:after{content:'';margin-top:6px}\n.menu-toggle{display:block;float:right;margin-left:25px}\n}\n@media (max-width:920px){\n.menu-toggle{margin-left:15px; display:block !important}\n.trading-iframe{\nmargin:0px;\nwidth: 100%;\n}\n.lefttabnav{display:block;margin-left:10px}\n.lefttab{display:none; }\n.righttab{\nwidth: 100% !important;\nmargin-bottom:20px !important;\nz-index:0 !important;\nposition:absolute !important;\ntop:630px !important;\n}\n.table{\nposition:absolute !important;\ntop:1180px !important;\nwidth:100%;\n}\nbody{\nheight: 1500px !important;\n}\n.pusher{\nheight:1300px;\n}\n.footer{\nposition:absolute;\nbottom:5;\nright:0;\nwidth:100%;\n}\n.left{\nposition: absolute;\nleft: 10px;\ntop: 0;\nwidth: 40% !important;\nmargin-right: 20px !important;\nmargin-bottom: 20px;\n}\n.left input{\nwidth: 100% ;\n}\n.right{\nposition: absolute;\nright: -30px !important;\ntop: 0;\nwidth: 40% !important;\n}\n.right button{\nmargin: 10px auto !important;\nheight: 70px !important;\nwidth: 80% !important;\n}\n.right input{\nmargin: 10px auto !important;\nwidth: 80% !important;\n}\n.clearfix{\ndisplay:block !important;\n}\n.icon-nav{\ndisplay:none;\n}\n}\n@media (max-width: 890px){\n.tabdiv, .walletdrop{\ntop: 25px !important;\n}\n}\n\n@media (min-width:920px){\n.lefttab{display:block !important; }\n.walletdrop{display:block !important; }\n.trading-iframe{margin-right:235px !important;}\n\n}\n\n.google-trans .goog-te-gadget-simple{\n    \n     background-color: #fff; \n     border: 0px;\n}\n" }} />
                    <div className="root-content">
                        <div className="pusher push-trading">
                            <div className="ds-table ds-rework">
                                <div className="row-cell row-run">
                                    <div className="latest-bid">
                                        <table className="wrap tl-table">
                                            <tbody>
                                                <tr height="30px">
                                                    <th className="nowrap" height="30px">Live forex:</th>
                                                    <td className width="100%" height="30px" style={{ maxHeight: '30px !important' }}>
                                                        <div className="tradingview-widget-container" ref={tradingvi}>
                                                            <div className="tradingview-widget-container__widget"></div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: '100%', height: '60px', padding: '0px', margin: '0px' }}>
                                <span className="lefttabnav float-left" onClick={() => {}}><i /></span>
                                <div style={{ zIndex: '9999 !important', position: 'absolute', top: '40px', left: '0px', width: '220px !important' }} className="lefttab">
                                    <div className="category ui option-select tabdiv selection dropdown" tabIndex={0} style={{ height: '60px', width: '220px', position: 'absolute' }}>
                                        <input type="hidden" defaultValue /><i className="dropdown icon" tabIndex={0}><div className="menu" tabIndex={-1} /></i><div className="default text">Forex</div>
                                        <div className="menu" tabIndex={-1}>
                                            <a href="#" className="item" onClick={() => { document.getElementById('forexscr').classList.remove('hidden'); document.getElementById('cryptoscr').classList.add('hidden'); document.getElementById('stockscr').classList.add('hidden'); }}>Forex</a>
                                            <a href="#" className="item" onClick={() => { document.getElementById('forexscr').classList.add('hidden'); document.getElementById('cryptoscr').classList.remove('hidden'); document.getElementById('stockscr').classList.add('hidden'); }}>Crypto</a>
                                            <a href="#" className="item" onClick={() => { document.getElementById('forexscr').classList.add('hidden'); document.getElementById('cryptoscr').classList.add('hidden'); document.getElementById('stockscr').classList.remove('hidden'); }}>Stock</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="wallet-drop-func" data-ng-func style={{ position: 'absolute', top: '40px', right: '0px', width: '250px' }}>
                                    <div className="ui dropdown amount-dropdown walletdrop" tabIndex={0} style={{ width: '250px', zIndex: 99 }}>
                                        <div className="text"><div className="amount-item">
                                            <div className="amount-val">
                                                <span style={{ marginTop: '10px' }}><b>{userdetails?.demobalance || 0}</b> <b>USD</b></span>
                                                <span style={{ position: 'absolute', fontSize: 'small', top: 0, right: '20px' }}><i className="fa fa-envelope-o" /> {userdetails?.email || ''}</span>
                                            </div>
                                            <span className="amount-net">Net Demo Balance: <b>{userdetails?.demobalance || 0}</b> <b ng-bind="w.currency" className="ng-binding">USD</b></span>
                                        </div></div>
                                        <i className="dropdown icon" tabIndex={0}><div className="menu" tabIndex={-1} /></i>
                                        <div className="menu" tabIndex={-1}>
                                            <div className="item active" role="button" tabIndex={0} style={{}}>
                                                <div className="amount-item">
                                                    <span className="amount-id"></span>
                                                    <div className="amount-val"><b>0</b> <b>USD</b></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="chat-platform-wrap minimized">
                                <hr />
                                <div className="theme-wrap dark-theme-wrap" style={{ width: '100%' }}>
                                    <div style={{ width: '220px', position: 'absolute', top: '0px', left: '0px', fontSize: 'small !important', color: '#FFFFFF !important', zIndex: '999 !important' }} className="lefttab">
                                        <div id="forexscr" className="screener">
                                            <div className="tradingview-widget-container">
                                                <div className="tradingview-widget-container__widget"></div>
                                            </div>
                                        </div>
                                        <div id="cryptoscr" className="screener hidden">
                                            <div className="tradingview-widget-container">
                                                <div className="tradingview-widget-container__widget" />
                                            </div>
                                        </div>
                                        <div id="stockscr" className="screener hidden">
                                            <div className="tradingview-widget-container">
                                                <div className="tradingview-widget-container__widget" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item"><Link to="/real" className="ui button op nobold" style={{ background: '#07b18c' }} > Switch To Real</Link></div>
                                    <div className="trading-iframe" id="trading" style={{ minHeight: '600px !important', height: '600px' }}>
                                        <div className="tradingview-widget-container">
                                            <div id="tradingview_eeb1c" style={{ minHeight: '600px !important', height: '600px', width: '100%' }} >
                                                <AdvancedRealTimeChart 
                                                    symbol={selectedPaird}
                                                    theme="dark"
                                                    locale="en"
                                                    autosize
                                                    hide_side_toolbar={false}
                                                    studies={[
                                                        "BB@tv-basicstudies",
                                                        "MASimple@tv-basicstudies",
                                                        "RSI@tv-basicstudies"
                                                    ]}
                                                ></AdvancedRealTimeChart>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ overflow: 'visible' }}  >
                                    <div className="clearfix" style={{ display: 'none' }} />
                                    <div style={{ width: '250px', position: 'absolute', top: 0, right: '0px' }} className="righttab">
                                        <div style={{ width: '200px', margin: '0 auto', color: '#FFFFFF' }}>
                                            <div className="line" />
                                            <div className="rightcontent left">
                                                <label>Option type: <span title="Select option type" className="ask">?</span></label>
                                                <div>
                                                    <select onChange={(e) => { ChangePairsToRender(e.target.value) }} className="category ui option-select selection dropdown" >
                                                        <option value="crypto">crypto</option>
                                                        <option value="stocks">Stocks</option>
                                                        <option value="forex">Forex</option>
                                                    </select>
                                                </div>
                                                <div className="line" />
                                                <label>Commodity: <span title="Select option type" className="ask">?</span></label>
                                                <div>
                                                    {TradingSection == "forex" && (
                                                        <select onChange={(e) => { setselectedPair(e.target.value) }} className="category ui option-select selection dropdown" >
                                                            {PairsToRender.map((d, i) => (<option key={i} value={d.symbol}>{d.symbol}</option>))}
                                                        </select>
                                                    )}
                                                    {TradingSection == "crypto" && (
                                                        <select onChange={(e) => { setselectedPair(e.target.value) }} className="category ui option-select selection dropdown">
                                                            {PairsToRender.map((d, i) => (<option key={i} value={d.tradingsymbol}>{d.symbol}</option>))}
                                                        </select>
                                                    )}
                                                    {TradingSection == "stocks" && (
                                                        <select onChange={(e) => { setselectedPair(e.target.value) }} className="category ui option-select selection dropdown">
                                                            {PairsToRender.map((d, i) => (<option key={i} value={d.name}>{d.symbol}</option>))}
                                                        </select>
                                                    )}
                                                </div>
                                                <div className="line" />
                                                <label>Platform Time: <span id="clockbox" /></label>
                                                <div className="line" />
                                                <label>Expiration Time: <span title="'Time' represents duration of the option." className="ask">?</span>
                                                    <time style={{ float: 'right', color: '#FF0000' }} id="time" /></label>
                                                <div>
                                                    <select className="category ui option-select selection dropdown" tabIndex={0}
                                                        name="time" id="time" required onChange={(e) => { setTradeTime(e.target.value) }}>
                                                        <option value="60">1min</option>
                                                        <option value="120">2min</option>
                                                        <option value="180">3min</option>
                                                        <option value="240">4min</option>
                                                        <option value="300">5min</option>
                                                        <option value="600">10min</option>
                                                        <option value="900">15min</option>
                                                        <option value="1800">30min</option>
                                                        <option value="3600">1 hour</option>
                                                    </select>
                                                </div>
                                                <div className="line" />
                                                <label>Amount: <span title="Trade amount in base currency of the trading account." className="ask">?</span></label>
                                                <div className="input-number-box">
                                                    <input type="text" onChange={(e) => { setAmountToTrade(e.target.value) }} value={AmountToTrade} />
                                                    <div className="input-number-more" />
                                                    <div className="input-number-less" /></div>
                                                <div className="line" />
                                                <span id="hiddenamt" value />
                                                <div className="profit-sum"><b><font color="#0D884E" size={2}><span id="profit" value /></font></b> <span className="profit-cur">Your Profit Is : USD {parseFloat(AmountToTrade || 0) * (parseFloat(percentage) / 100)} </span>
                                                </div>
                                                <div className="line" />
                                                <label>Percentage Return: <span title="Trade amount in base currency of the trading account." className="ask" /></label>
                                                <select className="category ui option-select selection dropdown" tabIndex={0}
                                                    name="time" id="time" required onChange={(e) => { setpercentage(e.target.value) }}>
                                                    <option value="5" >5%</option>
                                                    <option value="10" >10%</option>
                                                    <option value="20" >20%</option>
                                                    <option value="30" >30%</option>
                                                    <option value="40" >40%</option>
                                                    <option value="50" >50%</option>
                                                    <option value="60" >60%</option>
                                                    <option value="70" >70%</option>
                                                    <option value="80" >80%</option>
                                                    <option value="90" >90%</option>
                                                    <option value="100" >100%</option>
                                                </select>
                                            </div>
                                            <div className="line" />
                                            <div className="rightcontent right">
                                                <button className="ui button primal green" style={{ height: '50px', width: '170px', marginBottom: '10px', backgroundColor: '#07b18c' }} id="btn_trade" name="btn_trade" onClick={() => { PlaceOder("buy") }}>Buy</button>
                                                <label><a><font color="#fff">Strike Rate:</font></a> <span title="Trading current cap rate." className="ask" /></label>
                                                <select className="category ui option-select selection dropdown" tabIndex={0}
                                                    name="time" id="time" required >
                                                    <option value="20" >1% & 3%</option>
                                                    <option value="30" >2% & 3%</option>
                                                    <option value="40" >5% & 5%</option>
                                                    <option value="50" >2% & 5%</option>
                                                    <option value="60" >21% & 49%</option>
                                                </select>
                                                <div id="error" />
                                                <button className="ui button primal red" style={{ height: '50px', width: '170px', margin: '0 auto' }} id="btn_trade" name="btn_trade" onClick={() => { PlaceOder("sell") }}>Sell</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button className="ui button primal red" id="btn_trade" name="btn_trade" onClick={routeOrders}>View Open Orders</button>

                <div className="language langBox" style={{}}>
                    <img className="img-fluid mb-0" src="../images/icons/lang-b.png" alt="" style={{ height: '50px', width: 'auto' }} />
                    <div id="google_translate_element" />
                </div>
                
                <footer className="footer">
                    <div className="row clearfix">
                        <div className="float-left">
                            <span className="copy">© 2022 <span data-company>ATA-trades</span>. <span data-company-address>71 Cherry Court avenue London,  United Kingdom</span></span> <a href="/en/policies">Privacy policy</a>
                        </div>
                        <div className="float-right">
                            <ul className="soc-list">
                                <li>Follow us</li>
                                <li>
                                    <div className="footer-media">
                                        <div className="media-icons">
                                            <a href="#"><span><i className="fa fa-instagram" /></span></a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="footer-media">
                                        <div className="media-icons">
                                            <a href="#"><span><i className="fa fa-twitter-square" /></span></a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </footer>
            </div>
            {loading && (
                <div className="preloader js-preloader">
                    <div className="loader loader-inner-1">
                        <div className="loader loader-inner-2">
                            <div className="loader loader-inner-3"></div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Demo

// import React, { useEffect, useRef, useState, useContext } from 'react'

// import BrowserReal from '../BrowserPages/BrowserReal';
// import Mobilereal from '../MobilePages/Mobilereal';
// import { Helmet } from "react-helmet";
// // import TradingViewWidget, { Themes } from 'react-tradingview-widget';
// import { AdvancedRealTimeChart } from "react-ts-tradingview-widgets";
// import Mobilenav from '../Components/Mobilenav';
// import Browsernav from '../Components/Browsernav';
// import { CryptoPairs, Forexpairs, Stockpairs } from "../Pairs"
// import { f, database, storage, auth } from "../config";
// import db from "../config";
// import { GlobalContext } from "../Globalstate";
// import { useNavigate, Link } from "react-router-dom";
// import Swal from 'sweetalert2'
// import axios from 'axios';
// import firebase from 'firebase';
// // import ScriptTag from "react-script-tag";

// function Demo() {

//     const history = useNavigate();
//     const [{ userdetails, loggedin, tradingpair, openorders, adminstaus }, dispatch] = useContext(GlobalContext);
//     const [PairsToRender, setPairsToRender] = useState([])
//     const [TradingSection, setTradingSection] = useState("forex")
//     const [selectedPaird, setselectedPaird] = useState("EURUSD")
//     const [loading, setloading] = useState(true)
//     const [AmountToTrade, setAmountToTrade] = useState("")
//     const [Adminstas, setAdminstas] = useState("")

//     const [commodityPrice, setcommodityPrice] = useState("")
//     const [percentage, setpercentage] = useState("5")
//     const [TradeTime, setTradeTime] = useState("60")

//     const ChangePairsToRender = (values) => {
//         console.log("hgfufyfyufyfyf")
//         if (values == "crypto") {
//             setPairsToRender(CryptoPairs)
//             setTradingSection("crypto")
//             setselectedPaird(CryptoPairs[0].tradingsymbol)
//         }
//         else if (values == "stocks") {
//             setPairsToRender(Stockpairs)
//             setTradingSection("stocks")
//             setselectedPaird(Stockpairs[0].name)
//         }
//         else if (values == "forex") {
//             setPairsToRender(Forexpairs)
//             setTradingSection("forex")
//             setselectedPaird(Forexpairs[0].fromsymbol+Forexpairs[0].tosymbol)
//         }

//     }

//     const setselectedPair = (values) => {
//         setselectedPaird(values)
//     }

//     const PlaceOder = async (CallTYpe) => {
//         // if PairsToRender is empty tell user to select pair
//         Swal.fire({
//             title: `Place a ${CallTYpe} Trade on ${selectedPaird}?`,
//             text: "You won't be able to revert this!",
//             icon: 'warning',
//             showCancelButton: true,
//             confirmButtonColor: '#3085d6',
//             cancelButtonColor: '#d33',
//             confirmButtonText: 'Yes'
//         }).then((result) => {
//             if (result.isConfirmed) {
//                 RunTrade(CallTYpe)
//             }
//         })
//         console.log(CallTYpe)

//     }

//     const RunTrade = async (CallTYpe) => {
//         if (PairsToRender === []) {
//             Swal.fire(
//                 'No Selected Pair?',
//                 'Please Select A trading pair?',
//             )
//             return
//         }
//         if (TradingSection == "crypto") {
//             let obj = CryptoPairs.find(o => o.tradingsymbol === selectedPaird);
//             console.log(obj)
//             const istfetch = await axios.get(
//                 `https://api.coingecko.com/api/v3/coins/markets?ids=${obj.idist}&vs_currency=usd`
//             );
//             // I made use of coin to do aoll my crypto api searches
//             // const istfetch = await axios.get(`https://api.coincap.io/v2/assets?search=${obj.idist}`)
//             console.log(istfetch.data);
//             const secfetch = await axios.get(
//                 `https://api.coingecko.com/api/v3/coins/markets?ids=${obj.idsec}&vs_currency=usd`
//             );
//             // const secfetch = await axios.get(`https://api.coincap.io/v2/assets?search=${obj.idsec}`)
//             console.log(istfetch.data.data[0].priceUsd)
//             console.log(secfetch.data.data[0].priceUsd)

//             let pairpriceset = parseFloat(istfetch.data.data[0].priceUsd) / parseFloat(secfetch.data.data[0].priceUsd)
//             await setcommodityPrice(pairpriceset)
//             console.log(pairpriceset)
//             ProcessTrade(obj, CallTYpe, pairpriceset)
//         }
//         if (TradingSection == "forex") {
//              //add more keys
//              var ApiKeys = ['54Z4FY02OZUOH5K1', 'URBIA6Q117UKFF8E', 'D0KRVJ7PI65HXT38', "Y72BWRTTF57JL9BI", "V8XF1OKW9JY43FMX", "XX39XGKM4NPYKKJL", "BBRR88VJX0CV4J1H", "XQWZ1J3FSTOXHKZ6", "WY0FXXLGQE8A3MBT", "73MOPYFLO5RQ8AHY"];
//              var ApiKey = ApiKeys[Math.floor(Math.random() * ApiKeys.length)];
//              let obj = Forexpairs.find(o => o.symbol === selectedPaird);
//              const priceOfComodity = await axios.get(
//                  `https://www.alphavantage.co/query?function=FX_DAILY&from_symbol=${obj.fromsymbol}&to_symbol=${obj.tosymbol}&apikey=${ApiKey}`
//              );
//              // `https://www.alphavantage.co/query?function=FX_INTRADAY&from_symbol=${obj.fromsymbol}&to_symbol=${obj.tosymbol}&interval=1min&apikey=${ApiKey}`
 
//              // console.log(obj)
//              // console.log(priceOfComodity.data)
//              // console.log(priceOfComodity.data["Time Series FX (1min)"])
//              // console.log(priceOfComodity.data["Time Series FX (1min)"][Object.keys(priceOfComodity.data["Time Series FX (1min)"])[0]]["4. close"])
//              // const p = priceOfComodity.data["Time Series FX (1min)"][Object.keys(priceOfComodity.data["Time Series FX (1min)"])[0]]["4. close"]
 
//              console.log(obj)
//              console.log(priceOfComodity.data)
//              console.log(priceOfComodity.data["Time Series FX (Daily)"])
//              console.log(priceOfComodity.data["Time Series FX (Daily)"][Object.keys(priceOfComodity.data["Time Series FX (Daily)"])[0]]["4. close"])
//              const p = priceOfComodity.data["Time Series FX (Daily)"][Object.keys(priceOfComodity.data["Time Series FX (Daily)"])[0]]["4. close"]
//              ProcessTrade(obj, CallTYpe, p)

//         }
//         if (TradingSection == "stocks") {
//             //add more keys
//             var ApiKeys = ['54Z4FY02OZUOH5K1', 'URBIA6Q117UKFF8E', 'D0KRVJ7PI65HXT38', "Y72BWRTTF57JL9BI", "V8XF1OKW9JY43FMX", "XX39XGKM4NPYKKJL", "BBRR88VJX0CV4J1H", "XQWZ1J3FSTOXHKZ6", "WY0FXXLGQE8A3MBT", "73MOPYFLO5RQ8AHY"];
//             var ApiKey = ApiKeys[Math.floor(Math.random() * ApiKeys.length)];
//             let obj = Stockpairs.find(o => o.name === selectedPaird);
//             const priceOfComodity = await axios.get(
//                 `https://www.alphavantage.co/query?function=TIME_SERIES_INTRADAY&symbol=${obj.name}&interval=1min&apikey=${ApiKey}`
//             );
//             console.log(obj)
//             console.log(priceOfComodity.data)
//             console.log(priceOfComodity.data["Time Series (1min)"])
//             console.log(priceOfComodity.data["Time Series (1min)"][Object.keys(priceOfComodity.data["Time Series (1min)"])[0]]["4. close"])
//             const p = priceOfComodity.data["Time Series (1min)"][Object.keys(priceOfComodity.data["Time Series (1min)"])[0]]["4. close"]
//             ProcessTrade(obj, CallTYpe, p)
//             // Swal.fire(
//             //     'Succes!',
//             //     'Your Trade Has Been Executed.',
//             //     'success'
//             // )
//         }
//     }


//     const ProcessTrade = async (TradeDetails, CallTYpe, priceCom) => {
//         console.log(percentage, TradeTime)
//         // const nowTime = new Date();
//         var currenTTime = new Date();
//         currenTTime.setSeconds(currenTTime.getSeconds() + parseInt(TradeTime));
//         // ((t.getTime() - nowTime.getTime()) / 1000)   find number of seconds between two datetimes
//         console.log(currenTTime)

//         if (AmountToTrade == "") {
//             Swal.fire(
//                 'No Selected Price?',
//                 'select a price for the trade',
//             )
//             return
//         }

//         if (parseFloat(AmountToTrade) > parseFloat(userdetails.demobalance)) {
//             Swal.fire(
//                 'Low Balance',
//                 'Balance is not enough',
//             )

//             return
//         }

//         const currentbal = parseFloat(userdetails.demobalance) - parseFloat(AmountToTrade)
//         let formerorders
//         formerorders = userdetails.Demoopenorders
//         console.log(userdetails.Demoopenorders)
//         updateUserBalance(currentbal)

//         if (adminstaus == true) {
//             const new_order = {
//                 tradeDetails: TradeDetails,
//                 CallTYpe: CallTYpe,
//                 commodityPrice: priceCom,
//                 percentage: percentage,
//                 AmountToTrade: AmountToTrade,
//                 AdminOnline: "NO", //yes
//                 status: "pending", //"win"/"loose"
//                 ExpirationTime: currenTTime.getTime(),
//             }
//             updateDemoopenorders(new_order)
//             var userid = f.auth().currentUser;
//             var userids = userid.uid;
//             var washingtonRef2 = await db.collection("DemoOpenoders").doc("iEkPQf9sYa3Puj1IW76Z");
//             await washingtonRef2.update({
//                 alltrades: firebase.firestore.FieldValue.arrayUnion({ order: new_order, userID: userids })
//             });
//             // const newoders = formerorders.push(new_order)
//             // setopenordersD(newoders)


//             Swal.fire(
//                 'Succes!',
//                 'Your Trade Has Been Executed.',
//                 'success'
//             )

//             routeOrders()
//         } else if (adminstaus == false) {
//             const new_order = {
//                 tradeDetails: TradeDetails,
//                 CallTYpe: CallTYpe,
//                 commodityPrice: priceCom,
//                 percentage: percentage,
//                 AmountToTrade: AmountToTrade,
//                 AdminOnline: "NO", //yes
//                 status: "loose", //"win"/"loose"
//                 ExpirationTime: currenTTime.getTime(),
//             }
//             updateDemoopenorders(new_order)
//             // const newoders = formerorders.push(new_order)
//             // setopenordersD(newoders)


//             Swal.fire(
//                 'Succes!',
//                 'Your Trade Has Been Executed.',
//                 'success'
//             )

//             routeOrders()
//         }


//     }


//     const updateDemoopenorders = async (order) => {
//         var userid = f.auth().currentUser;
//         var userids = userid.uid;
//         var washingtonRef = await db.collection("users").doc(userids);
//         await washingtonRef.update({
//             Demoopenorders: firebase.firestore.FieldValue.arrayUnion(order)
//         });
//     }


//     const updateUserBalance = async (bal) => {
//         var userid = f.auth().currentUser;
//         var userids = userid.uid;
//         var washingtonRef = await db.collection("users").doc(userids);
//         await washingtonRef
//             .update({
//                 demobalance: bal
//             })
//             .then(function () {
//                 console.log("Document successfully up2dated!");
//                 // alert("withdrawal was successful we will get back to you");
//             })
//             .catch(function (error) {
//                 // The document probably doesn't exist.
//                 console.error("Error updating document: ", error);
//             });
//         // fetchuserdata();
//     };



//     const routeOrders = async () => {
//         console.log(userdetails.Demoopenorders)
//         var userid = f.auth().currentUser;
//         var userids = userid.uid;

//         var docRef = db.collection("users").doc(userids);
//         const fetching = await docRef
//             .get()
//             .then(function (doc) {
//                 if (doc.exists) {
//                     setdetails(doc.data());
//                     setopenordersD(doc.data().Demoopenorders)
//                     console.log(doc.data().Demoopenorders)
//                     setloading(false)
//                     history("/demorunnig")
//                 } else {
//                     console.log("No such document!");
//                     setloading(false)
//                 }
//             })
//             .catch(function (error) {
//                 console.log("Error getting document:", error);
//             });

//     }



//     useEffect(() => {
//         if (loggedin) {
//             console.log(userdetails);
//             console.log(userdetails.email);
//             setloading(false)
//         } else {
//             f.auth().onAuthStateChanged(function (user) {
//                 if (user) {
//                     var userid = f.auth().currentUser;
//                     var userids = userid.uid;
//                     fetchuserdata(userids);
//                     GetAdminStatus()
//                     setloggedin(true);
//                 } else {
//                     setloggedin(false);
//                     setloading(false)
//                     history("/");
//                 }
//             });
//         }
//     }, []);
//     const GetAdminStatus = async () => {
//         await db.collection("Adminonline").doc("szQGPiQbBF3FQ5yRvxVC")
//             .onSnapshot((doc) => {
//                 if (doc.exists) {
//                     setAdminstas(doc.data().Adminonline)
//                     console.log(doc.data().Adminonline)
//                     dispatch({ type: "setadminstaus", snippet: doc.data().Adminonline });
//                     // return doc.data().Adminonline
//                 } else {
//                     console.log("No such document!");
//                 }
//             });
//     }

//     const fetchuserdata = async (userid) => {
//         var docRef = db.collection("users").doc(userid);
//         const fetching = await docRef
//             .get()
//             .then(function (doc) {
//                 if (doc.exists) {
//                     setdetails(doc.data());
//                     setopenordersD(doc.data().Demoopenorders)
//                     console.log(doc.data().Demoopenorders)
//                     CheckTrades(doc.data().Demoopenorders, doc.data())
//                     console.log(doc.data().Demoopenorders)
//                     setloading(false)

//                 } else {
//                     console.log("No such document!");
//                     setloading(false)
//                 }
//             })
//             .catch(function (error) {
//                 console.log("Error getting document:", error);
//             });
//     };


//     const CheckTrades = async (OpenD, user) => {
//         let neworders = []
//         for (let i in OpenD) {
//             const nowTime = new Date();
//             const secs = ((OpenD[i].ExpirationTime - nowTime.getTime()) / 1000)

//             if (secs == 0 || secs < 0) {
//                 var Tradeindex = neworders.indexOf(OpenD[i])
//                 neworders.splice(Tradeindex, 1)
//                 console.log("fuck")
//                 //work on trdaes here
//                 //  console.log(userdetails.openoders)
//                 var userid = await f.auth().currentUser;
//                 var userids = userid.uid;

//                 var washingtonRef = await db.collection("users").doc(userids);
//                 await washingtonRef.update({
//                     Demoopenorders: firebase.firestore.FieldValue.arrayRemove(OpenD[i])
//                 })

//                 ///remove from admin open tardes
//                 const tarde = OpenD[i]
//                 var washingtonRef2 = await db.collection("DemoOpenoders").doc("iEkPQf9sYa3Puj1IW76Z");
//                 washingtonRef2.update({
//                     alltrades: firebase.firestore.FieldValue.arrayRemove({ tarde, userID: userids })
//                 }).then(function () {
//                     console.log("opppgfhfhchcc")
//                 })
//                     .catch(function (error) {
//                         console.log(error);
//                     });


//                 if (OpenD[i].status == "win") {
//                     await washingtonRef
//                         .update({
//                             demobalance: parseFloat(user.demobalance) + parseFloat(OpenD[i].AmountToTrade) + parseFloat(parseFloat(OpenD[i].AmountToTrade) * (parseFloat(OpenD[i].percentage) / 100))
//                         })
//                         .then(function () {
//                             console.log("Document successfully up2dated!");
//                             // routeOrders()

//                         })
//                         .catch(function (error) {
//                             console.error("Error updating document: ", error);
//                         });
//                     history("/real")

//                 } else if (OpenD[i].status == "loose") {
//                     //window.location.reload();
//                     console.log("passrby")
//                     // routeOrders()


//                 } else {
//                     await washingtonRef
//                         .update({
//                             demobalance: parseFloat(user.demobalance) + parseFloat(OpenD[i].AmountToTrade)
//                         })
//                         .then(function () {
//                             console.log("Document successfully up2dated!");
//                             // routeOrders()

//                         })
//                         .catch(function (error) {
//                             console.error("Error updating document: ", error);
//                         });
//                     history("/real")
//                 }


//                 var washingtonRef = await db.collection("users").doc(userids);
//                 await washingtonRef.update({
//                     Demoorderhistory: firebase.firestore.FieldValue.arrayUnion(OpenD[i]),
//                 });

//             } else {
//                 neworders.push(OpenD[i])
//                 console.log("jjjj")
//             }
//         }

//         setopenordersD(neworders.reverse())
//         console.log("bbibwcbyib")
//     }

//     const setopenordersD = (data) => {
//         console.log(data)
//         dispatch({ type: "setDemoopenorders", snippet: data });
//     };

//     const setdetails = (data) => {
//         dispatch({ type: "setuserdetails", snippet: data });
//     };


//     const setloggedin = (data) => {
//         dispatch({ type: "setloggedin", snippet: data });
//     };

//     useEffect(() => {
//         const script = document.createElement("script");
//         script.src =
//             "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
//         script.innerHTML = `
//         "symbols": [
//             {
//                 "proName": "FOREXCOM:SPXUSD",
//                 "title": "S&P 500"
//             },
//             {
//                 "proName": "FOREXCOM:NSXUSD",
//                 "title": "Nasdaq 100"
//             },
//             {
//                 "proName": "FX_IDC:EURUSD",
//                 "title": "EUR/USD"
//             },
//             {
//                 "proName": "BITSTAMP:BTCUSD",
//                 "title": "BTC/USD"
//             },
//             {
//                 "proName": "BITSTAMP:ETHUSD",
//                 "title": "ETH/USD"
//             }
//         ],
//             "showSymbolLogo": true,
//             "colorTheme": "dark",
//             "isTransparent": true,
//             "displayMode": "adaptive",
//             "locale": "en"
//         `;
//         tradingvi.current.appendChild(script);
//     }, []);

//     const tradingvi = useRef();
//     return (
//         <div>
//             <div className="root-content">
//                 <Helmet>
//                     <meta httpEquiv="content-type" content="text/html; charset=UTF-8" />
//                     <meta charSet="utf-8" />
//                     <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
//                     <title> ATA-trades Main </title>
//                     <meta name="description" content="            
// 														" />

//                     <link rel="shortcut icon" type="image/png" sizes="32x32" href="assets/img/favicon.png" />
//                     <link rel="shortcut icon" type="image/png" sizes="16x16" href="assets/img/favicon.png" />
//                     <link rel="canonical" href="dashboard" />
//                     <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1" />
//                     <link href="/dashboard/assets/css/css.css" rel="stylesheet" type="text/css" />
//                     <link rel="stylesheet" type="text/css" href="/dashboard/assets/inner.css" />
//                     <link rel="stylesheet" type="text/css" href="/dashboard/assets/app.css" />
//                     <link rel="stylesheet" type="text/css" href="/dashboard/assets/cs.css" />

//                     <script async="" src="/dashboard/assets/js/js.js"></script>
//                     <script type="text/javascript" src="/dashboard/assets/js/sweet-alert.js"></script>
//                     <script src="/dashboard/assets/inner.js"></script>
//                     <script src="/js/app.js"></script>

//                     <script src="/dashboard/assets/inner.js"></script>
//                     <script src="/dashboard/assets/js/vendor.js"></script>
//                     <script src="/dashboard/assets/app.js"></script>

//                     <script type="text/javascript" src="validation.min.js"></script>
//                     <script type="text/javascript" src="trade_script.js"></script>
//                     <script type="text/javascript" src="trade_script2.js"></script>
//                     <script src="https://use.fontawesome.com/4b789087e7.js"></script>
//                 </Helmet>



//                 <Mobilenav />

//                 <div id="google_translate_element"></div>
//                 {/* <ScriptTag type="text/javascript">
//                     {`

//                                   function googleTranslateElementInit() {
//                                   new google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element');
//                                     }
//                                      `}
//                 </ScriptTag>
//                 <ScriptTag
//                     type="text/javascript"
//                     src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
//                 ></ScriptTag> */}
//                 <div className="pusher" aria-hidden="false">
//                     <nav className="top-nav inner inner-new">
//                         <div className="top-bar" style={{ height: '50px' }}>
//                             <div className="head-row clearfix">
//                                 <div className="float-left ">
//                                     <div className="logosm">
//                                         <a ><img src="/assets/img/toplogo.png" alt="ProvidusOption" /></a>
//                                     </div>
//                                     {/*<a href="" class="top-bar-nav dinb"><i class="help-open"></i> <span>Support</span></a>*/}
//                                     <div className="ui item dropdown dropdown-call dinb" tabIndex={0}>
//                                         <div className="top-bar-nav">
//                                             <div className="phone-open" />
//                                         </div>
//                                         <div className="menu transition hidden" tabIndex={-1}>
//                                             <div className="item">
//                                                 <div className="phone-notice">Please input your phone number with<br />country code and we will immediately contact you.</div>
//                                                 <div>+<input className="call-input" placeholder="phone" type="text" maxLength={20} id="callback" style={{ width: '200px' }} /><button className="button ui green-bm" id="call_btn" onclick="callBack()">Call back</button></div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <span className="menu-toggle float-right"><i /></span>
//                                 <div className="float-right nav smcapy-nav">
//                                     <div className="ui item lang pointing dropdown" tabIndex={0}>
//                                         <input type="hidden" name="lang" />
//                                         <div className="default text">
//                                             <div id="google_translate_element" className="google-trans" />
//                                         </div>
//                                         <i className="dropdown icon" />
//                                     </div>
//                                     <div className="item"><span style={{ color: '#eee' }}>Account Status:</span>
//                                         <span style={{ color: '#0f0' }} className="blinkgreen"><i className="fa fa-check-circle" /> Active</span>
//                                     </div>
//                                     <div className="item"><a className="ui button op link a-green-hover" href="logout.php"><i className="fa fa-power-off" /> Exit</a></div>
//                                     <div className="item"><a className="ui button op nobold" style={{ background: '#07b18c' }} href="/deposit"> Account Funding</a></div>
//                                     {/*<div class="item"><a class="ui button op nobold" style="background:#E95524" href="acct-funding.php"><i class="fa fa-money"></i> Demo Account 0.00 USD</a></div> */}
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="top-line clearfix">
//                             <div className="row-30">
//                                 <ul className="icon-nav">
//                                     <li className="active"><a target="_blank" title="Charting tools" className="technic" href="chart.php" style={{ color: '#FFFFFF' }}><i className="fa fa-bar-chart" /></a></li>
//                                     <li className="active"><a title="Fundamental analysis" className="fundament" href="fundamental-analysis.php" target="_blank" style={{ color: '#FFFFFF' }}><i className="fa fa-pie-chart" /></a></li>
//                                     <li className="active"><a title="News" className="expert" href="news.php" target="_blank" style={{ color: '#FFFFFF' }}><i className="fa fa-tv" /></a></li>
//                                     <li className="active"><a title="Technical Analysis" className="ideas" href="technical-analysis.php" target="_blank" style={{ color: '#FFFFFF' }}><i className="fa fa-signal" /></a></li>
//                                     <li className="active"><a title="Economic calendar" className="calendar" href="calendar.php" target="_blank" style={{ color: '#FFFFFF' }}><i className="fa fa-calendar" /></a></li>
//                                 </ul>
//                             </div>
//                             <Browsernav />
//                         </div>
//                     </nav>
//                     <link rel="stylesheet" href="assets/platform.css" />
//                     <style dangerouslySetInnerHTML={{ __html: "\n.red{background:#f7495c !important}\n.red:hover{background:#FF6071 !important}\n.red:active{background:#FF0000 !important}\n.green:active{background:#008800 !important}\nhr{\nborder:none;\nfont-size:2px;\n}\n.hidden{\ndisplay:none;\n}\n.trading-iframe{margin-left:220px; margin-right:235px; min-height:600px !important; height: 600px;}\n.menu-toggle{display:none;height:30px;width:25px;cursor:pointer;margin-top:19px; z-index:99999999 !important;}.menu-toggle i,.menu-toggle:after,.menu-toggle:before{display:block;width:100%;height:2px;background:#2597c7}.menu-toggle i{margin-top:6px}.menu-toggle:before{content:'';margin-top:3px}.menu-toggle:after{content:'';margin-top:6px}\n\n.lefttabnav{display:none;height:30px;width:25px;cursor:pointer;margin-top:30px; position:relative; top:0px; left:0; z-index:9999 !important}\n.lefttabnav i,.lefttabnav:after,.lefttabnav:before{display:block;width:100%;height:2px;background:#2597c7}\n.lefttabnav i{margin-top:6px}\n@media (max-width:1139px){\n.lefttabnav{display:none;float:left;margin-left:0}\n.lefttabnav:before{content:'';margin-top:3px}.lefttabnav:after{content:'';margin-top:6px}\n.menu-toggle{display:block;float:right;margin-left:25px}\n}\n@media (max-width:920px){\n.menu-toggle{margin-left:15px; display:block !important}\n.trading-iframe{\nmargin:0px;\nwidth: 100%;\n}\n.lefttabnav{display:block;margin-left:10px}\n.lefttab{display:none; }\n.righttab{\nwidth: 100% !important;\nmargin-bottom:20px !important;\nz-index:0 !important;\nposition:absolute !important;\ntop:630px !important;\n}\n.table{\nposition:absolute !important;\ntop:1180px !important;\nwidth:100%;\n}\nbody{\nheight: 1500px !important;\n}\n.pusher{\nheight:1300px;\n}\n.footer{\nposition:absolute;\nbottom:5;\nright:0;\nwidth:100%;\n}\n.left{\nposition: absolute;\nleft: 10px;\ntop: 0;\nwidth: 40% !important;\nmargin-right: 20px !important;\nmargin-bottom: 20px;\n}\n.left input{\nwidth: 100% ;\n}\n.right{\nposition: absolute;\nright: -30px !important;\ntop: 0;\nwidth: 40% !important;\n}\n.right button{\nmargin: 10px auto !important;\nheight: 70px !important;\nwidth: 80% !important;\n}\n.right input{\nmargin: 10px auto !important;\nwidth: 80% !important;\n}\n.clearfix{\ndisplay:block !important;\n}\n.icon-nav{\ndisplay:none;\n}\n}\n@media (max-width: 890px){\n.tabdiv, .walletdrop{\ntop: 25px !important;\n}\n}\n\n@media (min-width:920px){\n.lefttab{display:block !important; }\n.walletdrop{display:block !important; }\n.trading-iframe{margin-right:235px !important;}\n\n}\n\n.google-trans .goog-te-gadget-simple{\n    \n     background-color: #fff; \n     border: 0px;\n}\n" }} />
//                     <div className="root-content">
//                         <div className="pusher push-trading">
//                             <div className="ds-table ds-rework">
//                                 <div className="row-cell row-run">
//                                     <div className="latest-bid">
//                                         <table className="wrap tl-table">
//                                             <tbody>
//                                                 <tr height="30px">
//                                                     <th className="nowrap" height="30px">Live forex:</th>
//                                                     <td className width="100%" height="30px" style={{ maxHeight: '30px !important' }}>
//                                                         {/* TradingView Widget BEGIN */}
//                                                         <div class="tradingview-widget-container" ref={tradingvi}>
//                                                             <div class="tradingview-widget-container__widget"></div>

//                                                         </div>
//                                                         {/* TradingView Widget END */}
//                                                     </td>
//                                                 </tr>
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div style={{ width: '100%', height: '60px', padding: '0px', margin: '0px' }}>
//                                 <span className="lefttabnav float-left" onclick="showtab()"><i /></span>
//                                 <div style={{ zIndex: '9999 !important', position: 'absolute', top: '40px', left: '0px', width: '220px !important' }} className="lefttab">
//                                     <div className="category ui option-select tabdiv selection dropdown" tabIndex={0} style={{ height: '60px', width: '220px', position: 'absolute' }}>
//                                         <input type="hidden" defaultValue /><i className="dropdown icon" tabIndex={0}><div className="menu" tabIndex={-1} /></i><div className="default text">Forex</div>
//                                         <div className="menu" tabIndex={-1}><a href="#" className="item" onclick="showed('forexscr')">Forex</a><a href="#" className="item" onclick="showed('cryptoscr')">Crypto</a>
//                                             <a href="#" className="item" onclick="showed('stockscr')">Stock</a></div></div>
//                                 </div>
//                                 <div className="wallet-drop-func" data-ng-func style={{ position: 'absolute', top: '40px', right: '0px', width: '250px' }}>
//                                     <div className="ui dropdown amount-dropdown walletdrop" tabIndex={0} style={{ width: '250px', zIndex: 99 }}>
//                                         <div className="text"><div className="amount-item">
//                                             <div className="amount-val">
//                                                 <span style={{ marginTop: '10px' }}><b>{userdetails.demobalance}</b> <b>USD</b></span>
//                                                 <span style={{ position: 'absolute', fontSize: 'small', top: 0, right: '20px' }}><i className="fa fa-envelope-o" /> {userdetails.email}</span>
//                                             </div>
//                                             <span className="amount-net">Net Demo Balance: <b>{userdetails.demobalance}</b> <b ng-bind="w.currency" className="ng-binding">USD</b></span>
//                                         </div></div>
//                                         <i className="dropdown icon" tabIndex={0}><div className="menu" tabIndex={-1} /></i>
//                                         <div className="menu" tabIndex={-1}>
//                                             {/* ngRepeat: w in info.balances */}<div className="item active" role="button" tabIndex={0} style={{}}>
//                                                 <div className="amount-item">
//                                                     <span className="amount-id">
//                                                     </span>
//                                                     <div className="amount-val"><b>0</b> <b>USD</b></div>
//                                                     {/* <span class="amount-net">Net Balance: <b>0</b> <b>USD</b></span>*/}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="chat-platform-wrap minimized">
//                                 <hr />
//                                 <div className="theme-wrap dark-theme-wrap" style={{ width: '100%' }}>
//                                     <div style={{ width: '220px', position: 'absolute', top: '0px', left: '0px', fontSize: 'small !important', color: '#FFFFFF !important', zIndex: '999 !important' }} className="lefttab">
//                                         <div id="forexscr" className="screener">
//                                             {/* TradingView Widget BEGIN */}
//                                             <div class="tradingview-widget-container" >
//                                                 <div class="tradingview-widget-container__widget"></div>

//                                             </div>
//                                             {/* TradingView Widget END */}
//                                         </div>
//                                         <div id="cryptoscr" className="screener hidden">
//                                             {/* TradingView Widget BEGIN */}
//                                             <div className="tradingview-widget-container">
//                                                 <div className="tradingview-widget-container__widget" />
//                                             </div>
//                                             {/* TradingView Widget END */}
//                                         </div>
//                                         <div id="stockscr" className="screener hidden">
//                                             {/* TradingView Widget BEGIN */}
//                                             <div className="tradingview-widget-container">
//                                                 <div className="tradingview-widget-container__widget" />
//                                             </div>
//                                             {/* TradingView Widget END */}
//                                         </div>
//                                     </div>







//                                     <div className="item"><Link to="/real" className="ui button op nobold" style={{ background: '#07b18c' }} > Switch To Real</Link></div>
//                                     <div className="trading-iframe" id="trading" style={{ minHeight: '600px !important', height: '600px' }}>
//                                         {/* TradingView Widget BEGIN */}
//                                         <div className="tradingview-widget-container">
//                                             <div id="tradingview_eeb1c" style={{ minHeight: '600px !important', height: '600px', width: '100%' }} >
//                                                 {/* <TradingViewWidget
//                                                     symbol={selectedPaird}
//                                                     theme={Themes.DARK}
//                                                     locale="en"
//                                                     autosize
//                                                     hide_side_toolbar={false}
//                                                     studies={[
//                                                         "BB@tv-basicstudies",
//                                                         "MASimple@tv-basicstudies",
//                                                         "RSI@tv-basicstudies"
//                                                     ]}

//                                                 /> */}
                                                
//                                                 <AdvancedRealTimeChart 
                                          
//                                                     symbol={selectedPaird}
//                                                     theme="dark"
//                                                     locale="en"
//                                                     autosize
//                                                     hide_side_toolbar={false}
//                                                     studies={[
//                                                         "BB@tv-basicstudies",
//                                                         "MASimple@tv-basicstudies",
//                                                         "RSI@tv-basicstudies"
//                                                     ]}
//                                                 ></AdvancedRealTimeChart>

//                                             </div>
//                                         </div>
//                                         {/* TradingView Widget END */}
//                                     </div>
//                                 </div>
//                                 <div style={{ overflow: 'visible' }}  >
//                                     <div className="clearfix" style={{ display: 'none' }} />
//                                     <div style={{ width: '250px', position: 'absolute', top: 0, right: '0px' }} className="righttab">
//                                         <div style={{ width: '200px', margin: '0 auto', color: '#FFFFFF' }}>
//                                             <div className="line" />
//                                             <div className="rightcontent left">
//                                                 <label>{/* react-text: 95 */}Option type: {/* /react-text */}<span title="Select option type" className="ask">?</span></label>
//                                                 <div>

//                                                     <select onChange={(e) => { ChangePairsToRender(e.target.value) }} className="category ui option-select selection dropdown" >
//                                                         <option value="crypto">crypto</option>
//                                                         <option value="stocks">Stocks</option>
//                                                         <option value="forex">Forex</option>
//                                                     </select>
//                                                 </div>
//                                                 <div className="line" />
//                                                 <label>{/* react-text: 95 */}Commodity: {/* /react-text */}<span title="Select option type" className="ask">?</span></label>
//                                                 <div>


//                                                     {
//                                                         TradingSection == "forex" && (
//                                                             <select onChange={(e) => { setselectedPair(e.target.value) }} className="category ui option-select selection dropdown" >
//                                                                 {
//                                                                     PairsToRender.map((d, i) => (
//                                                                         <option value={d.symbol}>{d.symbol}</option>
//                                                                     ))
//                                                                 }

//                                                             </select>
//                                                         )
//                                                     }
//                                                     {
//                                                         TradingSection == "crypto" && (
//                                                             <select onChange={(e) => { setselectedPair(e.target.value) }} className="category ui option-select selection dropdown">
//                                                                 {
//                                                                     PairsToRender.map((d, i) => (
//                                                                         <option value={d.tradingsymbol}>{d.symbol}</option>
//                                                                     ))
//                                                                 }

//                                                             </select>
//                                                         )
//                                                     }
//                                                     {
//                                                         TradingSection == "stocks" && (
//                                                             <select onChange={(e) => { setselectedPair(e.target.value) }} className="category ui option-select selection dropdown">
//                                                                 {
//                                                                     PairsToRender.map((d, i) => (
//                                                                         <option value={d.name}>{d.symbol}</option>
//                                                                     ))
//                                                                 }

//                                                             </select>
//                                                         )
//                                                     }

//                                                 </div>
//                                                 <div className="line" />
//                                                 <label>Platform Time: <span id="clockbox" /></label>
//                                                 <div className="line" />
//                                                 <label>{/* react-text: 107 */}Expiration Time: {/* /react-text */}<span title="'Time' represents duration of the option. In case of Fixed time mode, option 
// 			'Time' is the difference between the time when you enter to the market purchase the option, and option expiration time. If fixed time is switched off, 
// 			'Time' represents the difference between the time when option becomes available to purchase it on the market and option expiration time." className="ask">?</span>
//                                                     <time style={{ float: 'right', color: '#FF0000' }} id="time" /></label>
//                                                 <div>
//                                                     <select className="category ui option-select selection dropdown" tabIndex={0}
//                                                         name="time" id="time" required onChange={(e) => { setTradeTime(e.target.value) }}>

//                                                         <option value="60">1min</option>
//                                                         <option value="120">2min</option>
//                                                         <option value="180">3min</option>
//                                                         <option value="240">4min</option>
//                                                         <option value="300">5min</option>
//                                                         <option value="600">10min</option>
//                                                         <option value="900">15min</option>
//                                                         <option value="1800">30min</option>
//                                                         <option value="3600">1 hour</option>
//                                                     </select>
//                                                 </div>
//                                                 <div className="line" />
//                                                 <label>{/* react-text: 125 */}Amount: {/* /react-text */}<span title="Trade amount in base currency of the trading account." className="ask">?</span></label>
//                                                 <div className="input-number-box">
//                                                     <input type="text" onChange={(e) => { setAmountToTrade(e.target.value) }} />
//                                                     <div className="input-number-more" />
//                                                     <div className="input-number-less" /></div>
//                                                 <div className="line" />

//                                                 <div className="line" />
//                                                 <span id="hiddenamt" value />
//                                                 <div className="profit-sum"><b><font color="#0D884E" size={+2}><span id="profit" value /></font></b> <span className="profit-cur">Your Profit Is : USD {parseFloat(AmountToTrade) * (parseFloat(percentage) / 100)} </span>
//                                                 </div>
//                                                 <div className="line" />
//                                                 <label>{/* react-text: 125 */}Percentage Return: {/* /react-text */}<span title="Trade amount in base currency of the trading account." className="ask" /></label>
//                                                 <select className="category ui option-select selection dropdown" tabIndex={0}
//                                                     name="time" id="time" required onChange={(e) => { setpercentage(e.target.value) }}>
//                                                     <option value="5" >5%</option>
//                                                     <option value="10" >10%</option>
//                                                     <option value="20" >20%</option>
//                                                     <option value="30" >30%</option>
//                                                     <option value="40" >40%</option>
//                                                     <option value="50" >50%</option>
//                                                     <option value="60" >60%</option>
//                                                     <option value="70" >70%</option>
//                                                     <option value="80" >80%</option>
//                                                     <option value="90" >90%</option>
//                                                     <option value="100" >100%</option>

//                                                 </select>
//                                             </div>
//                                             <div className="line" />
//                                             <div className="rightcontent right">
//                                                 <button className="ui button primal green" style={{ height: '50px', width: '170px', marginBottom: '10px', backgroundColor: '#07b18c' }} id="btn_trade" name="btn_trade" onClick={() => { PlaceOder("buy") }}>Buy</button>
//                                                 <label>{/* react-text: 125 */}<a><font color="#fff">Strike Rate:</font></a> {/* /react-text */}<span title="Trading current cap rate." className="ask" /></label>
//                                                 <select className="category ui option-select selection dropdown" tabIndex={0}
//                                                     name="time" id="time" required >
//                                                     <option value="20" >1% & 3%</option>
//                                                     <option value="30" >2% & 3%</option>
//                                                     <option value="40" >5% & 5%</option>
//                                                     <option value="50" >2% & 5%</option>
//                                                     <option value="60" >21% & 49%</option>

//                                                 </select>
//                                                 <div id="error" />
//                                                 <button className="ui button primal red" style={{ height: '50px', width: '170px', margin: '0 auto' }} id="btn_trade" name="btn_trade" onClick={() => { PlaceOder("sell") }}>Sell
//                                                 </button>
//                                             </div>


//                                         </div>
//                                     </div>
//                                 </div>



//                             </div>
//                         </div>

//                     </div>


//                 </div>

//                 <button className="ui button primal red" id="btn_trade" name="btn_trade" onClick={routeOrders}>View Open Orders</button>




                
//                 <div className="language langBox" style={{}}>
//                 <img className="img-fluid mb-0" src="../images/icons/lang-b.png" alt="" style={{ height: '50px', width: 'auto' }} />
//                 <div id="google_translate_element" />
//               </div>
              
//                 <footer className="footer">
//                     <div className="row clearfix">
//                         <div className="float-left">
//                             <span className="copy">© 2022 <span data-company>ATA-trades</span>. <span data-company-address>71 Cherry Court avenue London,  United Kingdom</span></span> <a href="/en/policies">Privacy policy</a>
//                         </div>
//                         <div className="float-right">
//                             <ul className="soc-list">
//                                 <li>Follow us</li>
//                                 {/*<li>
//                     	<div class="footer-media">
// 		                    <div class="media-icons">
// 		                        <a href="https://www.facebook.com/ATA-trades"><span class="icon-mso-fb"></span></a>
// 		                    </div>
// 		                </div>
//                     </li>*/}
//                                 <li>
//                                     <div className="footer-media">
//                                         <div className="media-icons">
//                                             <a href="#"><span><i className="fa fa-instagram" /></span></a>
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li>
//                                     <div className="footer-media">
//                                         <div className="media-icons">
//                                             <a href="#"><span><i className="fa fa-twitter-square" /></span></a>
//                                         </div>
//                                     </div>
//                                 </li>
//                                 {/*<li><a href="https://www.linkedin.com/company/ATA-trades" class="soc_li"></a></li> 
//                     <li><a href="https://twitter.com/ATA-tradesCom" class="soc_tw"></a></li>
//                     <li><a href="https://www.facebook.com/ATA-tradesCom" class="soc_fb"></a></li>*/}
//                                 {/*<li><a href="" class="soc_yt"></a></li>*/}
//                             </ul>
//                         </div>
//                     </div>
//                 </footer>
//                 {/* Yandex.Metrika counter */}
//                 <noscript aria-hidden="false">&lt;div&gt;&lt;img src="https://mc.yandex.ru/watch/38379630" style="position:absolute; left:-9999px;" alt="" /&gt;&lt;/div&gt;</noscript>
//                 {/* /Yandex.Metrika counter */}
//                 <noscript aria-hidden="false">
//                     &lt;div style="display:inline;"&gt;
//                     &lt;img height="1" width="1" style="border-style:none;" alt="" src="//googleads.g.doubleclick.net/pagead/viewthroughconversion/1057644682/?guid=ON&amp;amp;script=0"/&gt;
//                     &lt;/div&gt;
//                 </noscript>
//                 {/* Global site tag (gtag.js) - Google AdWords: 824992907 */}
//             </div>
//             {
//                 loading && (
//                     <div class="preloader js-preloader">
//                         <div class="loader loader-inner-1">
//                             <div class="loader loader-inner-2">
//                                 <div class="loader loader-inner-3">
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 )
//             }
//         </div>
//     )
// }

// export default Demo